import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ScenarioQuestion = ({ question, selectedAnswer, onAnswerSelect }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="space-y-3">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
          {question?.text}
        </h2>
        
        {question?.scenario && (
          <div className="bg-muted rounded-xl p-4 md:p-6 space-y-3">
            {question?.scenarioImage && (
              <div className="w-full h-48 md:h-64 lg:h-80 rounded-lg overflow-hidden">
                <Image
                  src={question?.scenarioImage}
                  alt={question?.scenarioImageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <p className="text-sm md:text-base text-foreground leading-relaxed">
              {question?.scenario}
            </p>
          </div>
        )}

        <p className="text-sm md:text-base text-muted-foreground">
          {question?.instruction || "Quelle serait votre approche dans cette situation?"}
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3 md:gap-4">
        {question?.options?.map((option) => {
          const isSelected = selectedAnswer === option?.id;

          return (
            <button
              key={option?.id}
              onClick={() => onAnswerSelect(option?.id)}
              className={`
                w-full min-h-[80px] md:min-h-[96px] p-4 md:p-5 rounded-xl border-2 text-left transition-smooth
                ${isSelected ? 'border-primary bg-primary/5' : 'border-border bg-card'}
                hover:border-primary/50 hover:bg-muted cursor-pointer
              `}
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className={`
                  flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center transition-smooth
                  ${isSelected ? 'border-primary bg-primary' : 'border-border'}
                `}>
                  {isSelected && (
                    <Icon name="Check" size={14} color="#FFFFFF" />
                  )}
                </div>
                <div className="flex-1 min-w-0 space-y-2">
                  <p className="text-sm md:text-base font-medium text-foreground">
                    {option?.text}
                  </p>
                  {option?.description && (
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {option?.description}
                    </p>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ScenarioQuestion;